import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'z-clear-button',
  templateUrl: './clear-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearButtonComponent {
  @Output() click = new EventEmitter<any>();

  constructor() {}

  onClick(event: any) {
    this.click.emit(event);
  }
}
